<template>
	<div class="animated fadeIn">
		<div class="container">
			<user-data-form
				:form-import="form"
				:loading="loading"
				:errors-import="errors.errors"
				:user-information="data"
				:statuses="statuses"
				:processing="processing"
				:countries="countries"
				:access-groups="accessGroups"
				@requestData="requestUpdateUser" />
		</div>
	</div>
</template>
<script>

import User from '@/util/User';
import Country from '@/util/Country';
import { STATUSES as statuses } from '@/settings/Statuses';
import { ACCESS_GROUPS as accessGroups } from '@/settings/Permissions';
import { Validations as messages } from '@/translations';
import UserDataForm from './components/UserDataForm';

const countries = new Country();

export default {
	name: 'UpdateUser',
	messages,
	components: {
		UserDataForm,
	},
	data() {
		return {
			user: new User(),
			statuses,
			alert: new this.$Alert(),
			countries: [],
			accessGroups,
			form: {
				username: '',
				email: '',
				first_name: '',
				last_name: '',
				status: '',
				country: null,
				mobile_number: '',
				access_group: '',
				type: '',
				tfa_enabled: '',
			},
			processing: false,
		};
	},
	computed: {
		response() {
			try {
				const { data } = this.user.data.response;
				return data;
			} catch (error) {
				return {};
			}
		},
		data: {
			get() {
				try {
					return this.response.data.attributes;
				} catch (error) {
					return {};
				}
			},
			set(payload) {
				this.response.data.attributes = { ...this.response.data.attributes, ...payload };
			},
		},
		errors() {
			return this.user.data.errors;
		},
		loading() {
			try {
				return this.user.data.loading;
			} catch (error) {
				return false;
			}
		},
		routeId() {
			return this.$route.params.userId || this.$route.params.corporateId;
		},
	},
	watch: {
		routeId: () => {
			this.user.loadUser(this.routeId);
		},
	},
	created() {
		countries.getCountries().then((response) => {
			this.countries = response;
		});
		this.user.loadUser(this.routeId);
	},
	methods: {
		requestUpdateUser(payload) {
			this.processing = true;
			this.user.updateUser(this.routeId, payload).then(() => {
				try {
					this.alert.toast('success', this.translate('user_updated'));
				} finally {
					if (this.$route.params.userId) {
						this.$router.push({ name: 'Users' });
					} else if (this.$route.params.corporateId) {
						this.$router.push({ name: 'Corporates' });
					}
				}
			})
				.catch(() => { this.data = payload; })
				.finally(() => {
					this.processing = false;
				});
		},
	},
};
</script>
